import Portfolio from './Components/Portfolio';
function App() {
  return (
    <div className="App">
     <Portfolio />
    </div>
  );
}

export default App;
